import { escapeRegExp } from 'lodash-es';

const NUMBERED_VARIANT = /^(?<root>.*[^\d\s])[ \d]*\d$/;

export function nextAvailableThemeName(baseName: string, usedNames: readonly string[]): string {
  const rootName = NUMBERED_VARIANT.exec(baseName)?.groups?.root ?? baseName;
  const numbered = new RegExp(`^${escapeRegExp(rootName)}[ ]?(?<index>\\d+)?$`, 'i');

  let highestIndex = -1;

  for (const usedName of usedNames) {
    const match = numbered.exec(usedName);
    if (!match) {
      continue;
    }

    const index = match.groups?.index;
    highestIndex = Math.max(highestIndex, index === undefined ? 0 : Number.parseInt(index, 10));
  }

  return highestIndex > -1 ? `${rootName} ${highestIndex + 1}` : rootName;
}

export function isThemeNameInUse(name: string, usedNames: readonly string[]): boolean {
  const lowercased = name.toLowerCase();

  return usedNames.some((usedName) => usedName.toLowerCase() === lowercased);
}
